/**
 * Centralized API URL resolver for local XAMPP and React development.
 * Guarantees that whether running on React dev server (port 3000), 
 * Apache build (port 80), or LAN mobile IP, all requests reach the PHP API scripts.
 */
export const getApiUrl = (endpoint) => {
    // Clean leading slash if provided
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
    const protocol = window.location.protocol && window.location.protocol.startsWith('http') 
        ? window.location.protocol 
        : 'http:';
    const hostname = window.location.hostname || 'localhost';

    // 1. If running on a non-standard development port (like React on 3000), route directly to local Apache
    if (window.location.port && window.location.port !== '80' && window.location.port !== '443') {
        return `${protocol}//${hostname}/react1/myapp/public/${cleanEndpoint}`;
    }

    // 2. If served through local XAMPP Apache directly (e.g. localhost/react1/myapp/...)
    if (window.location.pathname.includes('/react1/myapp/')) {
        return `/react1/myapp/public/${cleanEndpoint}`;
    }

    // 3. On LIVE HOSTING (e.g. cPanel public_html, domain.com or domain.com/subfolder/)
    const basePath = window.location.pathname.endsWith('/')
        ? window.location.pathname
        : window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/') + 1);

    return `${basePath}${cleanEndpoint}`;
};

/**
 * Department Database URL Resolver.
 * Dynamically resolves to the local XAMPP agriculture database site when running on localhost/LAN,
 * or the live hosting URL when deployed on cPanel/domain.
 */
export const getDepartmentDbUrl = () => {
    const protocol = window.location.protocol && window.location.protocol.startsWith('http') 
        ? window.location.protocol 
        : 'http:';
    const hostname = window.location.hostname || 'localhost';

    // 1. Local development environment (localhost, 127.0.0.1, dev port, or LAN IP)
    if (
        hostname === 'localhost' || 
        hostname === '127.0.0.1' || 
        hostname.startsWith('192.168.') || 
        hostname.startsWith('10.') ||
        (window.location.port && window.location.port !== '80' && window.location.port !== '443')
    ) {
        return `${protocol}//${hostname}/agriculture/my_website/public`;
    }

    // 2. Live Hosting Server (cPanel / Live Domain)
    return `${window.location.origin}/agriculture/my_website/public`;
};
